/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Kantor_GInputs */

const en_tut_kantor_g = /** @type {(inputs: Tut_Kantor_GInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The virtual office is a pixel map of rooms and desks. The point is simple: know who is around, where, and whether they can be interrupted — without asking.`)
};

const id_tut_kantor_g = /** @type {(inputs: Tut_Kantor_GInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kantor virtual adalah peta pixel berisi ruang dan meja. Tujuannya sederhana: tahu siapa yang sedang ada, di mana, dan sedang sibuk atau tidak — tanpa harus bertanya.`)
};

/**
* | output |
* | --- |
* | "The virtual office is a pixel map of rooms and desks. The point is simple: know who is around, where, and whether they can be interrupted — without asking." |
*
* @param {Tut_Kantor_GInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_kantor_g = /** @type {((inputs?: Tut_Kantor_GInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Kantor_GInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_kantor_g(inputs)
	return en_tut_kantor_g(inputs)
});